import * as PIXI from "pixi.js";
import gsap from "gsap";
import PixiPlugin from "gsap/PixiPlugin";
import i18next from "i18next";
import Backend from "i18next-http-backend";
import Main from "./main";
import { DEBUG, DEFAULT_LOCALE, FALLBACK_LOCALE } from "./AppConfig";
import { loadAssets } from "./loading/AssetLoader";
import GlobalStore from "./services/GlobalStore";
import { DefaultSign } from "./signs/DefaultSign";
import SignController from "./services/SignController";
import { WebSocketClient } from "./services/WebSocketClient";
import { LoginMessage, MessageType } from "./models/Messages";
import GameConfig from "./GameConfig";

if (!DEBUG) {
  document.addEventListener("contextmenu", (evt) => {
    evt.preventDefault();
  });
}

(async () => {
  const config = await GameConfig.getInstance().load("config.json");

  gsap.registerPlugin(PixiPlugin);
  PixiPlugin.registerPIXI(PIXI);

  await i18next.use(Backend).init({
    lng: DEFAULT_LOCALE.toLocaleLowerCase(),
    fallbackLng: FALLBACK_LOCALE.toLocaleLowerCase(),
    debug: DEBUG,
    backend: {
      loadPath: "./locales/{{lng}}.json",
    },
  });

  const app = new PIXI.Application();

  await app.init({
    width: config.app.screenWidth,
    height: config.app.screenHeight,
    antialias: true,
    background: 0x212529,
  });

  document.body.appendChild(app.canvas);

  GlobalStore.setSignId(config.app.sign_id);

  (
    Object.keys(GlobalStore.layers) as Array<keyof typeof GlobalStore.layers>
  ).forEach((key) => {
    app.stage.addChild(GlobalStore.layers[key]);
  });

  // let loader: Loader | undefined;

  // console.time("Loading");

  await loadAssets({
    onLoadingAssetsLoaded: () => {
      // Display the loading scene
      // after loading scene assets are loaded
      // loader = new Loader(100, 100);
      // app.stage.addChild(loader);
      // GlobalStore.layers.loader.attach(loader);
    },
    onProgress: (progress) => {
      // if (loader) {
      //   loader.onData(progress);
      // }
    },
  });

  // console.timeEnd("Loading");

  // if (loader) {
  //   GlobalStore.layers.loader.detach(loader);
  //   app.stage.removeChild(loader);
  //   loader.finish();
  //   loader.destroy();
  // }
  // app.stage.removeChild(GlobalStore.layers.loader);

  // TODO: Instantiate SoundManager
  //

  const wsClient = new WebSocketClient({
    json: true,
    url: `${config.app.websocket_address}?sign_id=${config.app.sign_id}`,
  });
  wsClient.onOpen = () => {
    const loginMsg: LoginMessage = {
      msgType: MessageType.LOGIN,
      signId: GlobalStore.getSignId(),
    };
    wsClient.send(loginMsg);
  };
  const controller = SignController.init(wsClient, app, config);

  wsClient.connect();
  const sign = new DefaultSign(app.stage, controller);

  await Main(app, config);
})();
